import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./app/App";
import 'antd/dist/antd.min.css'
import reportWebVitals from "./reportWebVitals";
import Auth0ProviderWithNavigate from "./app/components/auth/Auth0Provider";

ReactDOM.render(
  <React.StrictMode>
    <Auth0ProviderWithNavigate>
      <App />
    </Auth0ProviderWithNavigate>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
